/**
 * Abre un PDF recibido como Blob en una pestaña nueva. Si el navegador bloquea
 * la ventana emergente, lo descarga con un enlace temporal. La URL se libera
 * pasado un minuto: la pestaña ya lo ha cargado.
 */
export function abrirPdf(pdf: Blob, nombre: string): void {
  const url = URL.createObjectURL(pdf)
  // Sin 'noopener': con él, window.open devuelve null siempre y se descargaría
  // además de abrirse. La URL es un blob del propio origen.
  const ventana = window.open(url, '_blank')
  if (!ventana) {
    const enlace = document.createElement('a')
    enlace.href = url
    enlace.download = nombre
    document.body.appendChild(enlace)
    enlace.click()
    enlace.remove()
  }
  setTimeout(() => URL.revokeObjectURL(url), 60_000)
}
